
import ControllerProduct from 'Controllers/ControllerProduct'
import PopupModal from '@/components/modal/productPopupModal'
import EditorTipTap from 'Editors/EditorTipTap'
import StarRating from '../ui/StarRating'

export default {
  components: {
    StarRating,
    ControllerProduct,
    PopupModal,
    EditorTipTap,
  },
  inject: ['componentData'],
  data() {
    return {
      privacy: false,
      textChange: false,
      activeClassName: 'description',
      activeProductID: 0,
      optionsTabs: [
        {
          name: 'title',
          label: 'Naslov',
          type: 'text',
        },
        {
          name: 'description',
          label: 'Opis',
          type: 'text',
        },
      ],
      commentBlock: false,
      modalState: false,
      slides: [],
      controllerProductRef: null,
      startingIndex: 0,
      spaceBetween: 10,
      activeSlide: 0,
      swiperOptionsMain: {
        slidesPerView: 1,
        loopedSlides: 1,
        on: {
          slideChange: () => {
            this.swiperThumbs.slideTo(this.swiperMain.activeIndex)
            this.activeSlide = this.swiperMain.activeIndex
          },
        },
      },
      swiperOptionsThumbnails: {
        direction: 'horizontal',
        slidesPerView: 5,
        loopedSlides: 1,
        startingIndex: this.startingIndex,
        spaceBetween: 10,
        centeredSlides: true,
        on: {
          slideChange: () => {
            this.swiperMain.slideTo(this.swiperThumbs.activeIndex, 600)
          },
          click: () => {
            this.swiperMain.slideTo(this.swiperThumbs.clickedIndex, 600)
          },
        },
        breakpoints: {
          640: {
            slidesPerView: 5,
          },
          1024: {
            direction: 'vertical',
            slidesPerView: 'auto',
            loopedSlides: 4,
            spaceBetween: 15,
          },
        },
      },
    }
  },
  computed: {
    // activeProductMedia() {
    //   if (
    //     !this.controllerProductRef ||
    //     !this.controllerProductRef.activeProduct ||
    //     !this.controllerProductRef.activeProduct.media ||
    //     !this.controllerProductRef.activeProduct.media.length
    //   )
    //     return []
    //   return this.controllerProductRef.activeProduct.media
    // },
    defaultSlideIndex() {
      if (
        this.activeProductMedia &&
        this.activeProductMedia.length &&
        this.activeProductMedia.length >= 3
      ) {
        return this.activeProductMedia
          .map((el) => {
            return el.default
          })
          .indexOf(true)
      } else {
        return 0
      }
    },
    editorData() {
      const clearHTML = (string) => string.replace(/<\/*\w*\/*>/g, '')
      const {
        description = '',
        instructions = '',
        details = '',
      } = this.componentData.linkMeta
      return {
        description: clearHTML(description),
        instructions: clearHTML(instructions),
        details: clearHTML(details),
      }
    },
  },

  mounted() {
    if (
      this.controllerProductRef &&
      this.controllerProductRef.activeProduct.media &&
      this.controllerProductRef.activeProduct.media.length
    ) {
      this.controllerProductRef.activeProduct.media.sort(
        (a, b) => a.order - b.order
      )
    }
    this.$watch(
      // watch for product-controller active id of configurable single product
      () => {
        return (
          this.$refs.productController &&
          this.$refs.productController.activeProductId
        )
      },
      (val) => {
        this.activeProductID = val
      }
    )
    if (this.$refs.productController) {
      this.controllerProductRef = this.$refs.productController
    }
    if (
      this.controllerProductRef &&
      this.controllerProductRef.activeProduct.media &&
      this.controllerProductRef.activeProduct.media.length
    ) {
      this.slides = this.controllerProductRef.activeProduct.media
      this.controllerProductRef.activeProduct.media.sort(
        (a, b) => a.order - b.order
      )
      // this.remapProductImages(
      //   this.controllerProductRef.activeProduct.media.length
      // )
      // this.$nextTick(() => {
      //   if (this.swiperMain) {
      //     this.swiperMain.slideTo(this.startingIndex, 600)
      //   }
      // })
    }
  },
  methods: {
    // getDefaultImage() {
    //   let array = []
    //   if (
    //     this.$refs.productController &&
    //     this.$refs.productController.product.media &&
    //     this.$refs.productController.product.media.length
    //   ) {
    //     array = this.$refs.productController.product.media
    //     let defaultImageIndex = 0
    //     defaultImageIndex = array.map((el) => el.default).indexOf(true)
    //     const element = array[defaultImageIndex]
    //     array.splice(defaultImageIndex, 1)
    //     array.splice(this.startingIndex, 0, element)
    //   }
    // },
    // remapProductImages(length) {
    //   if (length && length > 3) {
    //     this.startingIndex = 2
    //   } else if (length === 3) {
    //     this.startingIndex = 1
    //   } else {
    //     this.startingIndex = 0
    //   }
    //   this.getDefaultImage()
    // },
    changeStatement() {
      this.privacy = !this.privacy
    },
    expandText() {
      this.textChange = !this.textChange
    },
    genRearrangedSlides(arr, fromIndex, toIndex) {
      if (arr && arr.length >= 3) {
        const element = arr[fromIndex]
        arr.splice(fromIndex, 1)
        arr.splice(toIndex, 0, element)
        return arr
      }
      return arr
    },
    showPopupModal(arg) {
      this.modalState = arg
    },
    currencyNameSwitch(price) {
      if (!price) return
      return price.replace('HRK', 'Kn')
    },
    closeBlock() {
      this.commentBlock = false
    },
    showHideBlock() {
      this.commentBlock = !this.commentBlock
    },
    setActiveClass(className) {
      this.activeClassName = className
    },
    getActiveClass() {
      return this.activeClassName
    },
  },
}
